<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-25 16:11:31
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-05-12 18:47:07
-->
<template>
	<div class="date flex flex-align-center">
		<div class="date-select">
			<div class="item flex" :class="{ 'yx-color-primary': active === item.days }" @click="cut(item.days)" v-for="item in dayArr" :key="item.id">
				<span>{{ item.name }}</span>
				<slot name="explain" :explain="item"></slot>
			</div>
		</div>
		<el-date-picker
			class="ml-12"
			v-if="showPicker"
			v-model="value"
			:clearable="clearable"
			size="mini"
			type="daterange"
			@change="chooseTimeFun"
			value-format="yyyy-MM-dd"
			range-separator="至"
			start-placeholder="开始日期"
			end-placeholder="结束日期"
			:picker-options="pickerOptions"
		></el-date-picker>
	</div>
</template>

<script>
import { fastDatePick } from '@/utils/dataMap';
import { calculateDays, calDate, disabledDate } from '@/utils/common';
import {
	startOfDay,
	endOfDay,
	parseISO,
	getDay,
	startOfWeek,
	subWeeks,
	endOfWeek,
	subDays,
	startOfMonth,
	subMonths,
	endOfMonth,
	getDate,
} from 'date-fns';
export default {
	name: 'dataView',
	props: {
		showPicker: {
			type: Boolean,
			default: true,
		},
		days: {
			type: Number,
			default: 30,
		},
		isToDay: {
			type: Boolean,
			default: false,
		},
		disableDays: {
			type: Number,
			default: 30,
		},
		startEndTime: {
			type: Array,
			default: () => [],
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		weekMonth: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			value: calDate(30),
			active: 30,
			dayArr: fastDatePick,
			pickerOptions: {
				disabledDate: time => disabledDate(time, 30),
			},
		};
	},
	created() {
		this.dayArr = this.isToDay ? [{ id: 1, name: '今天', days: 0 }, ...fastDatePick] : fastDatePick;
		this.dayArr = this.weekMonth ? [...this.dayArr, { id: 6, name: '本周', days: 'week' }, { id: 7, name: '本月', days: 'month' }] : this.dayArr;
		const { days, disableDays } = this;
		this.active = calculateDays(this.startEndTime) || days;
		this.value = this.startEndTime || calDate(days);
		this.pickerOptions = {
			disabledDate: time => disabledDate(time, disableDays, false),
		};
	},
	methods: {
		resetData() {
			const { days } = this;
			this.value = calDate(days);
			this.active = days;
		},
		getData() {
			this.emitDateChange(this.value);
		},
		cut(days) {
			if (days === 'week' || days === 'month') {
				const today = new Date();
				let start_time, end_time;
				const calculateWeekDates = () => {
					const weekStartOptions = { weekStartsOn: 1 };
					if (getDay(today) === 1) {
						start_time = Math.trunc(startOfWeek(subWeeks(today, 1), weekStartOptions).valueOf() / 1000);
						end_time = Math.trunc(endOfWeek(subWeeks(today, 1), weekStartOptions).valueOf() / 1000);
					} else {
						start_time = Math.trunc(startOfWeek(today, weekStartOptions).valueOf() / 1000);
						end_time = Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
					}
				};
				const calculateMonthDates = () => {
					if (getDate(today) === 1) {
						start_time = Math.trunc(startOfMonth(subMonths(today, 1)).valueOf() / 1000);
						end_time = Math.trunc(endOfMonth(subMonths(today, 1)).valueOf() / 1000);
					} else {
						start_time = Math.trunc(startOfMonth(today).valueOf() / 1000);
						end_time = Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
					}
				};
				if (days === 'week') {
					calculateWeekDates();
				} else if (days === 'month') {
					calculateMonthDates();
				}
				this.start_time = start_time;
				this.end_time = end_time;
				this.value = [start_time, end_time].map(timestamp => new Date(timestamp * 1000));
			} else {
				this.value = calDate(days);
			}
			this.active = days;
			this.emitDateChange(this.value);
		},
		chooseTimeFun(val) {
			const [start, end] = val || [];
			const params = {
				from_time: start ? startOfDay(parseISO(start)).getTime() / 1000 : '',
				to_time: end ? parseInt(endOfDay(parseISO(end)).getTime() / 1000) : '',
			};
			this.$emit('changeDate', params, this.active);
			this.active = '';
		},
		emitDateChange([from_time, to_time]) {
			const params = {
				from_time: from_time.getTime() / 1000,
				to_time: parseInt(to_time.getTime() / 1000),
			};
			this.$emit('changeDate', params, this.active);
		},
	},
};
</script>

<style lang="less" scoped>
.date {
	::v-deep .el-date-editor {
		width: 214px;
	}
	.date-select {
		display: flex;
		align-items: center;
		border-radius: 2px;
		font-size: 12px;
		color: #666;
		.item {
			height: 28px;
			line-height: 28px;
			padding: 0 12px;
			cursor: pointer;
			border: 1px solid #eee;
			box-sizing: border-box;
			&:nth-child(n + 2) {
				border-left: none;
			}
		}
	}
}
</style>
